import { useEffect } from "react";
import $ from "jquery";

const useReloadButton = (setReloadToggle) => {
  useEffect(() => {
    const appendRefreshButton = () => {
      const $pagerLast = $(".k-pager-last");
      const $existingReloadBtn = $pagerLast.next("#reloadBtn");

      if ($pagerLast.length > 0 && $existingReloadBtn.length === 0) {
        $(
          "<span id='reloadBtn' class='k-i-refresh k-icon pl-3 cursor-pointer'></span>"
        ).insertAfter($pagerLast);
      }
    };

    appendRefreshButton();

    const reloadButton = document.getElementById("reloadBtn");

    const reloadHandler = () => {
      setReloadToggle((prev) => !prev);
    };

    if (reloadButton) reloadButton.addEventListener("click", reloadHandler);

    return () => {
      if (reloadButton)
        reloadButton.removeEventListener("click", reloadHandler);
    };
  }, [setReloadToggle]);
};

export default useReloadButton;
